import React, { forwardRef } from 'react';
import '../../styles/vendorregistration.css';
import submitted from '../../assets/ac/submit.png'

const SubmitRegistrationPage = forwardRef((props, ref) => {
  const {
    onSubmit
  } = props;
  return (
    <>
      <div className="submit-container">
        <div className="success-icon">
          <img width='45px' height='40px' src={submitted} />
        </div>
        <h2 className="page-title">Submit Your Registration</h2>
        <p className="page-description">
          Please review all the information you previously typed in
          the past steps, and if all is okay, submit your registration.
        </p>

        <button className="submit-button" onClick={onSubmit}>Submit</button>
      </div>
    </>
  );
});
export default SubmitRegistrationPage;